import { Box, SxProps, useTheme } from '@mui/material';
import { useColorScheme } from 'hooks/useColorScheme';

type VectorLogoProps = {
  size?: number;
  sx?: SxProps;
  className?: string;
  /** Fill color for the logo SVG paths. Defaults to `theme.palette.text.primary` in light mode and `theme.palette.primary.main` in dark mode. */
  color?: string;
};

export const VectorLogo = (props: VectorLogoProps): JSX.Element => {
  const theme = useTheme();
  const { isDarkMode } = useColorScheme();
  const defaultColor = isDarkMode
    ? theme.palette.primary.main
    : theme.palette.text.primary;
  const { size = 148, sx, className, color = defaultColor } = props;

  return (
    <Box sx={sx} className={className} data-testid="app-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 148 148"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="WatchDuty"
      >
        <path
          d="M62.3332 1C64.4066 17.7362 44.7047 39.1859 40.631 44.0526C31.7255 54.6919 25 65.9574 25 80.2548C25 93.5494 30.2026 105.619 38.6652 114.504L68.5466 144.701C69.2663 145.43 70.1239 146.009 71.0694 146.404C72.0149 146.798 73.0295 147.001 74.0541 147C75.0787 146.999 76.0929 146.794 77.0376 146.398C77.9824 146.001 78.8389 145.421 79.5572 144.691L109.335 114.504C117.797 105.619 123 93.5494 123 80.2538C123 75.9219 122.448 71.7186 121.41 67.7142L121.444 67.6988C121.444 67.6988 116.778 47.2973 101.222 22.1863C101.222 32.5071 98.6278 40.5227 94.4983 47.498C89.9538 32.8231 80.7822 15.1456 62.3332 1Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};
